const pushToDataLayer = (event) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
};

export const trackLandingEvent = (eventName, payload = {}) => {
  const event = {
    event: 'groundaale_landing',
    eventName,
    timestamp: new Date().toISOString(),
    ...payload,
  };

  pushToDataLayer(event);

  if (process.env.NODE_ENV !== 'production') {
    // Keep signal visible for local QA and product iteration.
    // eslint-disable-next-line no-console
    console.log('[GroundAale Analytics]', event);
  }
};
